import * as Sentry from "@sentry/react";
import { CUSTOMER_SUMMARY_URL } from "../constants/endpoints";
import axiosClient from "./axios";

class FetchCustomerSummaryService {
  static async fetchCustomerSummary(
    shopId: string,
    phoneNumber: string,
    userFirebaseId: string | null,
    startDate?: string,
    endDate?: string
  ) {
    const body: Record<string, unknown> = { shopId, phoneNumber };
    if (userFirebaseId) body.userFirebaseId = userFirebaseId;
    if (startDate) body.startDate = startDate;
    if (endDate) body.endDate = endDate;

    return Sentry.startSpan(
      {
        op: "http.client",
        name: "POST /admin/shop/customer/summary",
      },
      async () => {
        return axiosClient.post(CUSTOMER_SUMMARY_URL, body);
      }
    );
  }
}

export default FetchCustomerSummaryService;
